import React, {useEffect, useState, useRef, Fragment} from "react";
import { Link, NavLink, useLocation,useParams, } from 'react-router-dom';
import axios from "axios";
import '../../assets/css/single_cource/course.css';
///import Header from '../components/Header';
import CourseAside from '../Course_single/CourseAside';
import CourseDetail from '../Course_single/CourseDetail';
import CourseVideo from '../Course_single/CourseVideo';
import Master_Front from "../../pages/Master_Front";
import Meeting_view_single from "../../components/Meeting_single/Meeting_view_single";
import Comments_bk from "../../components/Comments/Comments_bk";


import clientconfigwebapp, {
    check_login_appbk,
    empty_bk,
    FormatNumberByhkh,
    scrollTo_uphk,
    convert_to_english_strhk,
    show_menu_hh, Token_get_appbk, seo_setmetabk, modal_login_reg_bk_show
} from '../../clientconfigwebapp';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {Button} from "@mui/material";
import Meeting_Lessons from "../../components/Meeting_single/Meeting_Lessons";

const Course_single_view = (props) => {

    const location = useLocation()
    const {id_post_getuser} = useParams();
    const location_get_urlbk = useLocation();

    const [loadinghkfullshow, Setloadinghkfullshow] = useState("false");

    const [page_info_data, setData_Page_info] = useState([]);
    const [data_lessons_get, setData_lessons] = useState([]);
    const [page_list_comments, setData_list_comments] = useState([]);
    const [position , setPosition] = useState("1")
    const [link_buy , set_link_buy] = useState("")
    const [status_buy , set_status_buy] = useState("")

    const [active_tab_curent , set_active_tab_curent] = useState("tab1")

    /*  start profile */
    const [wallet_balance, setData_wallet_balance] = useState('0');
    const [first_name_profile,setData_first_name_profile] = useState('');
    const [last_name_profile,setData_last_name_profile] = useState('');
    /*  end profile */





    useEffect(() => {

        scrollTo_uphk();
        /// localStorage.setItem('last_post_product',''); ////ddddd امن کردن
        Load_api_page();
    }, [location_get_urlbk]);


    const Load_api_page= () => {

        Setloadinghkfullshow("true");
        const data_form = {post_id:id_post_getuser};
        const config = {
            headers: { Authorization: `Bearer ${Token_get_appbk()}` }
        };

        axios.post(`${clientconfigwebapp.siteurl}api/v1/posts-single`,data_form,config)
            .then((res) => {

                Setloadinghkfullshow("false");



                if(String(res.data.data).length > 0) {
                    setData_Page_info(res.data.data[0]);




                    if(check_login_appbk()==false){
                       /// set_link_buy('login');
                    }


                    if(String(res.data.data[0].id_post).length > 0) {

                        set_link_buy('checkout/' + String(res.data.data[0].id_post));
                    }


                    if(String(res.data.data[0].status_buy).length > 0) {

                        set_status_buy(res.data.data[0].status_buy);

                        if(res.data.data[0].status_buy=="yes"){
                            set_link_buy('panel/my-course/' + String(res.data.data[0].id_post) + "/" +  String(res.data.data[0].lesson_id_default));
                        }


                    }


                    if(String(res.data.data[0].meta_title_seo).length > 0 &&  String(res.data.data[0].meta_descr_seo).length > 0) {
                        seo_setmetabk({
                            title: String(res.data.data[0].meta_title_seo),
                            metaDescription: String(res.data.data[0].meta_descr_seo)
                        });
                    }




                    // if(String(page_info_data).length > 0){
                    //     if(String(page_info_data.title_post).length > 0){ document.title = page_info_data.title_post;}
                    //
                    // }


                    ///console.log(page_info_data)
                }else{
                    if(String(res.data.msgwebapp).length > 0)  toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                }


                if(String(res.data.wallet_inventory).length > 0) {  setData_wallet_balance(res.data.wallet_inventory); }
                if (!empty_bk(res.data.first_name_profile)) { setData_first_name_profile(res.data.first_name_profile); localStorage.setItem('first_name_Get',res.data.first_name_profile);    }
                if (!empty_bk(res.data.last_name_profile)) { setData_last_name_profile(res.data.last_name_profile); localStorage.setItem('last_name_Get',res.data.last_name_profile);    }


                if(String(res.data.list_Comment_post).length > 0) {
                    setData_list_comments(res.data.list_Comment_post);

                }

                if(String(res.data.data_lessons).length > 0) {
                    setData_lessons(res.data.data_lessons);
                }






            }).catch((err) =>{
            Setloadinghkfullshow("false");
            toast.error('خطای اتصال به سرور کد 5156', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
        });





    }


    const Handler_login_show_bk = () => {
        modal_login_reg_bk_show("login_reg_check_view_modal");
    }


    const handleClick_send_comment = () => {

        if(check_login_appbk()==false){
            set_link_buy('/login');
            toast.error('برای ثبت نظر باید وارد حساب کاربری شوید.', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
            return false;
        }

        Setloadinghkfullshow("true");

        var get_comment_element=document.getElementById("comment_text_input");
        var parent_get_element=document.getElementById("parent_get");
        var get_comment_textb="";
        if(!empty_bk(get_comment_element)){
            toast.error('نظر خود را تایپ کنید.', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
            return false;
        }
        get_comment_textb=String(get_comment_element.value);


        const data_form = {post_id:id_post_getuser,post_type:'course',description:get_comment_textb,parent:String(parent_get_element.value)};
        const config = {
            headers: { Authorization: `Bearer ${Token_get_appbk()}` }
        };

        axios.post(`${clientconfigwebapp.siteurl}api/v1/send-comment`,data_form,config)
            .then((res) => {

                Setloadinghkfullshow("false");

                if(String(res.data.data).length > 0 && String(res.data.data)=="login-show" ) {
                    ///redirect_navigate("/login")
                    set_link_buy('/login');
                    toast.error('برای ثبت نظر باید وارد حساب کاربری شوید.', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                    return false;
                }

                if(String(res.data.data).length > 0) {

                    if(String(res.data.data)=="success") {
                        toast.success(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                        document.getElementById("parent_get").value="";
                        document.getElementById("comment_text_input").value="";

                        ///set_comment_text("");
                    }



                }else{
                    if(String(res.data.msgwebapp).length > 0)  toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                }

            }).catch((err) =>{
            Setloadinghkfullshow("false");
            toast.error('خطای اتصال به سرور کد 7657', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
        });












        // if(check_login_appbk()==false){
        //     redirect_navigate("/login",{replace:true});
        // }
        // if (empty_bk(get_comment_text)) {
        //     toast.error('نظر خود را تایپ کنید.', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
        //     return false;
        // }else{
        //
        //     toast.success("نظر شما با موفقیت ارسال شد و پس از تایید توسط مدیر نمایش داده میشود.", {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
        //     document.getElementById("comment_text_input").value="";
        // }





    };



    return (
    <>

        <Master_Front   wallet_balance={wallet_balance} first_name_profile={first_name_profile} last_name_profile={last_name_profile} >
            <ToastContainer />
                <section className='flexRowBetCenter course-hero-container'>


                    <div className={"signle-header-right-box"}>
                        <h1 className={"title-post-head"}>{page_info_data.title_post}</h1>
                        <p className={"summeary_text_single contentdotline contentdotline-1"}>{page_info_data.summary_text}</p>
                    </div>


                    <div className='flexRowBetCenter signle-header-right-box'>
                        <Link to='/'>
                            <svg width='1.25rem' height='1.25rem' fill="none" stroke="currentColor" viewBox="0 0 24 24"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                      d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"></path>
                            </svg>
                        </Link>
                        <Link to='/'>
                            <svg xmlns="http://www.w3.org/2000/svg" width='1rem' height='1rem' fill="none"
                                 viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                      d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"></path>
                            </svg>
                            <span>صفحه اصلی</span>
                        </Link>
                    </div>


                </section>
                <section className='flexRowBetStart course-main-wrapper'>
                    <CourseAside  page_list_comments={page_list_comments} page_info_data={page_info_data}  link_buy={link_buy} status_buy={status_buy} data_lessons_get={data_lessons_get} />
                    <section className=' course-center-content'>
                        <div className='flexRowStartCenter'>






                            <Button type={"button"} onClick={()=>set_active_tab_curent("tab1")} className={
                            (() => {

                                if(String(active_tab_curent)=="tab1"){
                                    return ' btn-tab-single-nav flexRowStartCenter tab-active-bk ';
                                }else{

                                    return ' btn-tab-single-nav flexRowStartCenter';
                                }
                            })()

                            }>
                                <svg xmlns="http://www.w3.org/2000/svg" width="1rem" height="1rem" fill="currentColor"
                                     className="ml-2" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd"
                                          d="M0 .5A.5.5 0 0 1 .5 0h4a.5.5 0 0 1 0 1h-4A.5.5 0 0 1 0 .5Zm0 2A.5.5 0 0 1 .5 2h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Zm9 0a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm-9 2A.5.5 0 0 1 .5 4h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm5 0a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm7 0a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm-12 2A.5.5 0 0 1 .5 6h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5Zm8 0a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm-8 2A.5.5 0 0 1 .5 8h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm7 0a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Zm-7 2a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5Zm0 2a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Z"></path>
                                </svg>
                                توضیحات دوره
                            </Button>


                            <Button type={"button"}
                                    onClick={()=>set_active_tab_curent("tab2")}
                                className={
                                    (() => {

                                        if(String(active_tab_curent)=="tab2"){
                                            return ' btn-tab-single-nav flexRowStartCenter tab-active-bk ';
                                        }else{

                                            return ' btn-tab-single-nav flexRowStartCenter';
                                        }
                                    })()

                                }
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="1rem" height="1rem" fill="currentColor"
                                     className="ml-2" viewBox="0 0 16 16">
                                    <path
                                        d="M2.5 3.5a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-11zm2-2a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1h-7zM0 13a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 16 13V6a1.5 1.5 0 0 0-1.5-1.5h-13A1.5 1.5 0 0 0 0 6v7zm6.258-6.437a.5.5 0 0 1 .507.013l4 2.5a.5.5 0 0 1 0 .848l-4 2.5A.5.5 0 0 1 6 12V7a.5.5 0 0 1 .258-.437z"></path>
                                </svg>
                                جلسات دوره
                            </Button>


                            <Button type={"button"}
                                    onClick={()=>set_active_tab_curent("tab3")}
                                    className={
                                        (() => {

                                            if(String(active_tab_curent)=="tab3"){
                                                return ' btn-tab-single-nav flexRowStartCenter tab-active-bk ';
                                            }else{

                                                return ' btn-tab-single-nav flexRowStartCenter';
                                            }
                                        })()

                                    }
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="1rem" height="1rem" fill="currentColor"
                                     className="ml-2" viewBox="0 0 16 16">
                                    <path
                                        d="M2.5 3.5a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-11zm2-2a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1h-7zM0 13a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 16 13V6a1.5 1.5 0 0 0-1.5-1.5h-13A1.5 1.5 0 0 0 0 6v7zm6.258-6.437a.5.5 0 0 1 .507.013l4 2.5a.5.5 0 0 1 0 .848l-4 2.5A.5.5 0 0 1 6 12V7a.5.5 0 0 1 .258-.437z"></path>
                                </svg>
                              نظرات
                            </Button>
                        </div>










                        {
                            String(active_tab_curent)=="tab1" ?( <Fragment><CourseDetail  page_info_data={page_info_data}   /></Fragment> ) : (<Fragment></Fragment>)
                        }



                        {
                            String(active_tab_curent)=="tab2" ?( <Fragment>  <Meeting_Lessons cource_id_get={page_info_data.id_post}  data_lessons={data_lessons_get} page_view={'single'} data_info_details={page_info_data} lesson_id={''}  /></Fragment> ) : (<Fragment></Fragment>)
                        }


                        {

                            String(active_tab_curent)=="tab3" ?(<Fragment>


                                <div className="flexColStartStart w-100 sin-mu-sec-container">
                                    <div className="flexColStartStart w-100 sin-mu-com-con">

                                        <input type="text" name="parent" id="parent_get" style={{display: "none"}}/>

                                        {

                                            check_login_appbk() == false ? (

                                                <Fragment>
                                                    <p style={{
                                                        "color": "black",
                                                        "backgroundColor": "#fff17980",
                                                        "padding": "6px",
                                                        "display": "block",
                                                        "width": "100%",
                                                        "marginTop": "17px",
                                                        "paddingTop": "25px",
                                                        "paddingBottom": "25px",
                                                        "borderRadius": "11px",
                                                        "fontSize": "12px",
                                                        "textAlign": "center"
                                                    }}>برای ثبت نظر بایستی <button type={"button"} style={{"backgroundColor":"transparent","border":"none","fontSize":"14px","padding":"0px","color":"#3b82f6","fontWeight":"bold"}}  onClick={Handler_login_show_bk}  >وارد</button> شوید </p>
                                                </Fragment>
                                            ) : (
                                                <Fragment>
                                                    <textarea style={{"width":"100%","fontFamily":"'iran'","padding":"12px","height":"108px","backgroundColor":"#fafafa","marginBottom":"15px","border":"solid 1px #3b82f6","borderRadius":"9px"}} id="comment_text_input" name="comment_text_input" className="comment_text_input" placeholder="نظر خود را تایپ کنید..."></textarea>
                                                    <br/>
                                                    <center>
                                                        <button onClick={handleClick_send_comment} style={{
                                                            "width": "206px",
                                                            "marginBottom": "16px",
                                                            "textAlign": "center",
                                                            "fontSize": "13px",
                                                            "marginTop": "3px",
                                                            "height": "48px",
                                                            "paddingTop": "11px"
                                                        }} className="btn-bh btn-grey-bh">
                                                            ارسال نظر
                                                        </button>
                                                    </center>
                                                    <div style={{
                                                        "width": "100%",
                                                        "borderTop": "solid 1px #92929282"
                                                    }}></div>

                                                </Fragment>

                                            )

                                        }


                                        <span style={{
                                            "display": "inline-block !important",
                                            "paddingTop": "16px",
                                            "marginBottom": "21px",
                                            "fontSize": "17px",
                                            "paddingRight": "13px",
                                            "borderBottom": "solid 3px red",
                                            "paddingBottom": "9px",
                                            "textAlign": "center",
                                            "paddingLeft": "13px",
                                            "marginRight": "8px"
                                        }}>نظرات</span>

                                        <Comments_bk data_info_list={page_list_comments} cource_id_get={page_info_data.id_post}
                                                     data_lessons={data_lessons_get} page_view={'single'}
                                                     data_info_details={page_info_data} lesson_id={''}/>

                                    </div>
                                </div>





                            </Fragment>) : (<Fragment></Fragment>)
                        }

                    </section>
                </section>
        </Master_Front>

    </>
    );
}

export default Course_single_view;